import { render } from "./LoadingSpinner.vue?vue&type=template&id=e2cdd6b0&scoped=true"
const script = {}

import "@/assets/css/loadingSpinner.css?vue&type=style&index=0&id=e2cdd6b0&lang=css&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2cdd6b0"]])

export default __exports__